module.exports = __webpack_public_path__ + "img/card_icon_manejo_solicitudes_transferencia_equipos.5f2dbbc1.svg";